module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.ce60baa0.svg";